import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import { sample, reject, random } from 'lodash'
import { colors } from '../util'

import Footer from './Footer/Footer'
import { LogoWrapper, Backg, ShapeContainer } from './Splash/styles.css'
import CircleStatic from './CircleStatic/CircleStatic'
import Logo from './Logo/Logo'

import micaLogo from '../assets/mica-logo'
import mgsLogo from '../assets/mgs2018logo.svg'
import mgsLogoArrow from '../assets/mgs2018logoarrow.svg'
import yearLogo from '../assets/mgs2018year.svg'
import gallery from '../assets/galleries'

const themes = {
  orangeBlue: {
    color: colors.alt.orange,
    colorAlt: colors.alt.blue,
    colorText: colors.alt.orange,
  },
  orangeGreen: {
    color: colors.alt.orange,
    colorAlt: colors.alt.green,
    colorText: colors.alt.orange,
  },
  orangePink: {
    color: colors.alt.orange,
    colorAlt: colors.alt.pink,
    colorText: colors.alt.orange,
  },
  blueOrange: {
    color: colors.alt.blue,
    colorAlt: colors.alt.orange,
    colorText: colors.alt.blue,
  },
  blueGreen: {
    color: colors.alt.blue,
    colorAlt: colors.alt.green,
    colorText: colors.alt.blue,
  },
  bluePink: {
    color: colors.alt.blue,
    colorAlt: colors.alt.pink,
    colorText: colors.alt.blue,
  },
  greenOrange: {
    color: colors.alt.green,
    colorAlt: colors.alt.orange,
    colorText: colors.alt.green,
  },
  greenBlue: {
    color: colors.alt.green,
    colorAlt: colors.alt.blue,
    colorText: colors.alt.green,
  },
  greenPink: {
    color: colors.alt.green,
    colorAlt: colors.alt.pink,
    colorText: colors.alt.green,
  },
  pinkOrange: {
    color: colors.alt.pink,
    colorAlt: colors.alt.orange,
    colorText: colors.alt.orange,
  },
  pinkBlue: {
    color: colors.alt.pink,
    colorAlt: colors.alt.blue,
    colorText: colors.alt.blue,
  },
  pinkGreen: {
    color: colors.alt.pink,
    colorAlt: colors.alt.green,
    colorText: colors.alt.green,
  },
}

class Page extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      theme: sample(themes),
      flipX: random(),
      flipY: random(),
      circleX: random(15, 85),
      circleY: random(15, 85),
      rotate: sample([0, 90, 180, 270]),
      loaded: false,
    }
    this.changeTheme = this.changeTheme.bind(this)
    // set background color
    document.body.style.backgroundColor = this.state.theme.colorAlt
  }

  componentDidMount() {
    this.setState({ loaded: true })
  }

  changeTheme() {
    const t = reject(themes, this.state.theme)
    const s = sample(t)
    this.setState({ theme: s })
  }

  render() {
    const { children, siteName, shapeSize, shapePos, isInternal, closePopup, ...props } = this.props
    const { theme, rotate, flipX, flipY, loaded, circleX, circleY } = this.state
    return (
      <ThemeProvider theme={theme}>
        <Backg>
          <ShapeContainer
            rotate={rotate}
            flipX={flipX}
            flipY={flipY}
            size={shapeSize}
            pos={shapePos}
          >
            {gallery}
          </ShapeContainer>

          {siteName && loaded && <CircleStatic x={circleX} y={circleY} />}

          <LogoWrapper pos="top" justifyContent="space-between" pgSize={shapeSize} pgPos={shapePos}>
            <Logo
              primary
              sttc
              logoSrc={isInternal ? mgsLogoArrow : mgsLogo}
              siteName={siteName}
              isInternal={isInternal}
              closePopup={closePopup}
            />
            {micaLogo}
          </LogoWrapper>

          <LogoWrapper pos="bottom" justifyContent="flex-end">
            <Logo right primary sttc logoSrc={yearLogo} siteName={siteName} />
          </LogoWrapper>
          <div>{children}</div>
          <Footer />
        </Backg>
      </ThemeProvider>
    )
  }
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
}
Page.defaultProps = {
  id: 'page',
}
export default Page
